<template>
  <div class="all-order descriptions1">
    <div class="all-order-content">
      <div style="padding: 20px;width: 1200px">
        <el-descriptions title="基本信息"
                         :column="2"
                         border>
          <el-descriptions-item style="width: 200px;"
                                label="展商名称">{{ queryData.exhibitorName
                    }}</el-descriptions-item>
          <el-descriptions-item label="展馆">{{ queryData.boothJson ? JSON.parse(queryData.boothJson)[0].Hall : ''
                    }}</el-descriptions-item>
          <el-descriptions-item label="展区">{{ queryData.exhibitionArea }}</el-descriptions-item>
          <el-descriptions-item label="展位号">{{ queryData.boothJson ? JSON.parse(queryData.boothJson)[0].Code : ''
                    }}</el-descriptions-item>
          <el-descriptions-item label="胸卡总数">10</el-descriptions-item>
          <el-descriptions-item label="已填报胸卡数量">{{ submitNumber }}</el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="填报表单"
                         :column="2"
                         border
                         style="margin-top: 30px;">
          <el-descriptions-item :label="item.name"
                                v-for="(item, index) in list"
                                :key="index">
            <span v-if="item.state">已提交 <span class="lookClass"
                    style="margin-left: 20px;"
                    @click="goTab(index)">立即查看</span></span>
            <span v-else>未提交</span>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="会刊免费登记表">kooriookami</el-descriptions-item> -->
          <!-- <el-descriptions-item label="会刊广告征订表">18100000000</el-descriptions-item>
                    <el-descriptions-item label="参展展品信息申报表">苏州市</el-descriptions-item>
                    <el-descriptions-item label="增租家具及电信服务一览表">苏州市</el-descriptions-item>
                    <el-descriptions-item label="展位楣板信息登记表">苏州市</el-descriptions-item>
                    <el-descriptions-item label="展台现场拆除&安装施工价目表">苏州市</el-descriptions-item>
                    <el-descriptions-item label="参展商胸卡信息登记表">苏州市</el-descriptions-item>
                    <el-descriptions-item label="标准展台搭建变更申请表">苏州市</el-descriptions-item> -->
        </el-descriptions>
      </div>

      <!-- <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：2020/12/12 00:00:00，可提醒展商及时提交信息</p>
                </el-empty>
            </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'all-order',
  data() {
    return {
      submitNumber: '',
      list1: [],
      list: [
        {
          date: '',
          name: '会刊免费登记表',
          state: false,
          key: 'JournalFree',
          url: '/exhibition/index/exinfo/catalogue',
          type: true,
        },
        {
          date: '',
          name: '参展展品信息申报表',
          state: false,
          key: 'Product',
          url: '/exhibition/index/exinfo/catalogue2',
          type: true,
        },
        {
          date: '',
          name: '展位楣板信息登记表',
          state: false,
          key: 'Lintel',
          url: '/exhibition/index/exinfo/catalogue3',
          type: true,
        },
        {
          date: '',
          name: '参展商胸卡信息登记表',
          state: false,
          key: 'Card',
          url: '/exhibition/index/exinfo/catalogue4',
          type: true,
        },
        {
          date: '',
          name: '会刊广告征订表',
          state: false,
          key: 'JournalAdvert',
          url: '/exhibition/index/exinfo/catalogue5',
        },
        {
          date: '',
          name: '现场广告征订表',
          state: false,
          key: 'SceneAdvert',
          url: '/exhibition/index/exinfo/catalogue6',
        },
        {
          date: '',
          name: '增租家具及电信服务一览表',
          state: false,
          key: 'RentedFurnitureAndTelecommunicationsService',
          url: '/exhibition/index/exinfo/catalogue8',
        },
        {
          date: '',
          name: '展台现场拆除&安装施工价目表',
          state: false,
          key: 'DemolitionBoothAndInstallationConstruction',
          url: '/exhibition/index/exinfo/catalogue9',
        },
        {
          date: '',
          name: '标准展台搭建变更申请表',
          state: false,
          key: 'StandardBoothConstructionChange',
          url: '/exhibition/index/exinfo/catalogue7',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      exhibitor: 'loginModule/getExhibitor',
    }),
    queryId() {
      return this.$route.query.id
    },
    queryData() {
      let data = sessionStorage.getItem('sessData')
      return JSON.parse(data)
    },
  },
  mounted() {
    this.getState()
  },
  methods: {
    ...mapActions({
      setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
      totalList: 'exhibitionModule/totalList', //获取统计状态
      receiptGet: 'hostSetModule/receiptGet',
      uploadReceiptrecord: 'exhibitionModule/uploadReceiptrecord', //上传
      getReceiptrecord: 'exhibitionModule/getReceiptrecord', //获取回执上传 状态
    }),
    goDetail() {
      this.$router.push('/exhibition/index/order/detail-order')
    },
    //获取状态
    async getState() {
      let res = await this.totalList(this.queryId)
      if (res) {
        res.forEach((item, index) => {
          this.list.forEach((item1, index) => {
            if (item.key == item1.key) {
              item1.state = true
            }
            if (item.key == 'Card') {
              this.submitNumber = item.extendedProperties.SubmitNumber
            }
          })
        })
      }
    },
    goTab(e) {
      let string = e + 2 + ''
      this.$emit('switchBrand', string)
    },
  },
}
</script>
<style lang="scss">
.descriptions1 {
  th {
    width: 220px;
  }
  td {
    width: 300px;
  }
}
</style>
<style lang="scss" scoped>
.all-order {
  min-width: 1000px;
  padding: 30px;
  min-height: 500px;

  &-content {
    background: #fff;

    .goods {
      width: 18%;
      padding: 10% 0;
      display: inline-block;
      position: relative;
      margin: 0 3px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
      }
    }

    .goods-e {
      position: absolute;
      left: 100%;
      top: 30%;
      font-weight: bold;
    }

    .operation {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
</style>